class ShoppingCart extends HTMLElement {
    constructor(noListeners = false) {
        super();
        this.noListeners = noListeners;
        noListeners ? this.getTotalProductsInCart() : this.clickEventListeners();
    }

    updateTotalItemsCount(totalItems, quantityAdded = null) {
        const { totalItemsCount } = this.cartComponents();
        totalItemsCount.forEach(itemCount => {            

            if(totalItems != 0 && quantityAdded == null || totalItems == null) {
                itemCount.parentElement.classList.replace('hidden', 'flex')
            } else {
                itemCount.parentElement.classList.replace('flex', 'hidden'); 
                this.renderEmptyCartSection();
            }

            quantityAdded != null ? itemCount.textContent = Number(itemCount.textContent) + Number(quantityAdded) : itemCount.textContent = totalItems;
        });
    }

    getTotalProductsInCart() {
        fetch('/cart.js')
        .then(response => response.json())
        .then(cartData => {
            cartData.item_count >= 1 ? this.updateTotalItemsCount(cartData.item_count) : null;
        })
        .catch(error => {
            console.error('Error fetching cart:', error);
        });
    }

    renderEmptyCartSection() {
        const { emptyCartSection, cartWrapper } = this.cartComponents();
        if(emptyCartSection != null && cartWrapper != null) {
            emptyCartSection.classList.replace('hidden', 'block')
            cartWrapper.classList.add('hidden');
        }
    }

    removeLineItemFromHtml(lineItemID) {
        const lineItem = document.getElementById(`product-${lineItemID}`);
        lineItem != null ? lineItem.remove() : null;
    }

    updateOrderSummary(cartData) {
        const { cartSubtotal, cartTotal ,orderSummaryDiscount, cartCurrency } = this.cartComponents();
            if(cartTotal.length > 0) {
                cartTotal.forEach(total => {
                    total.textContent = this.formatMoney(cartData.total_price, cartCurrency);
                })
            }
            cartTotal != null ? this.formatMoney(cartData.total_price, cartCurrency) : null;
            cartSubtotal != null ? cartSubtotal.textContent = this.formatMoney(cartData.items_subtotal_price, cartCurrency) : null;
            orderSummaryDiscount != null ? orderSummaryDiscount.textContent = this.formatMoney(cartData.total_discount, cartCurrency) : null;
    }

    addProductToCart(productID, quantity, checkoutRedirect = false, grindOption = null, rechargeGift = null, sellingPlanID = null, giftForm = null) {

        const formData = {
            'items': [{
                'id': Number(productID),
                'quantity': Number(quantity),
            }]
        };

        if(grindOption !== null) {
            formData.items[0].properties = {
                'Grind': grindOption
            };
        }

        if (rechargeGift !== null) {
          formData.items[0].properties = {
            '__rc_gift_recipient_first_name': rechargeGift[0],
            '__rc_gift_recipient_last_name': rechargeGift[1],
            '__rc_gift_recipient_email': rechargeGift[2],
            '__rc_gift_recipient_note': rechargeGift[3],
            '__rc_gift_sender_name': rechargeGift[4],
            '__rc_gift_notification_scheduled_at': rechargeGift[5]
          };
        }

        if(sellingPlanID !== '') {
            formData.items[0].selling_plan = sellingPlanID;
        }

        if(giftForm !== null && giftForm.name !== '' && giftForm.email !== '') {
            formData.items[0].properties = {
                'Gift Name': giftForm.name,
                'Gift Email': giftForm.email
            };
        }

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(response =>  response.json()).then(data => {
            if(data.status && data.message) {
                this.toggleErrorMessage(data.description, null, true);
                return;
            }
            this.toggleErrorMessage(null, null, true);
            this.updateTotalItemsCount(null, quantity);
            this.addProductToDrawer(data);
            checkoutRedirect ? window.location.href = `/checkout?cart_token=${data.token}` : null;
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    }

    updateCartNotes(message) {
        fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                'note': message
            })
        })
        .then(response => response.json()).then(data => {
            console.log(data);
        })
        .catch(error => {
            console.error('Error:', error);
        });
    }

    removeProductFromCart(itemKey) {
        fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                'id': itemKey, 
                'quantity': 0
            })
        }).then(response => response.json()).then(data => {
            this.removeLineItemFromHtml(itemKey);
            this.updateTotalItemsCount(data.item_count);
            this.updateOrderSummary(data);

            if(document.getElementById('empty-drawer-cart') != null && data.item_count == 0) {
                document.getElementById('empty-drawer-cart').classList.replace('hidden', 'block');
                document.getElementById('cart-drawer-container').classList.replace('block', 'hidden');
                document.getElementById('cart-drawer-footer').classList.replace('block', 'hidden');
                document.getElementById('cart-drawer-total-items').classList.replace('flex', 'hidden');
            }

        }).catch(error => {
            // Handle any errors
            console.error('Error updating cart:', error);
        });
    }

    updateProductPrice(cartData, itemKey) {
        const { cartCurrency } = this.cartComponents();

        cartData.items.forEach(item => {
            if (item.key == itemKey) {
                let productCard = document.getElementById(`product-${itemKey}`);
                // Update the product price
                productCard.querySelectorAll('.product-original-price').forEach(originalPrice => {
                    originalPrice.textContent = this.formatMoney(item.line_price, cartCurrency);
                });
                //Update price before discount
                if(productCard.querySelectorAll('.price-before-discount').length > 0) {
                    productCard.querySelectorAll('.price-before-discount').forEach(priceBeforeDiscount => {
                        priceBeforeDiscount.textContent = this.formatMoney(item.original_line_price, cartCurrency);
                    });
                }
            }
        });
    } 

    updateProductQuantity(itemKey, quantity) {
        fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                'id': itemKey, 
                'quantity': quantity
            })
        }).then(response => response.json()).then(data => {

            if(data.status && data.message) {
                this.toggleErrorMessage(data.message, itemKey)
                return;
            }
            this.toggleErrorMessage(null, itemKey);
            
            this.updateOrderSummary(data);
            this.updateTotalItemsCount(data.item_count);
            this.updateProductPrice(data, itemKey);
        }).catch(error => {
            // Handle any errors
            console.error('Error updating cart:', error);
        });
    }

    toggleErrorMessage(message = null, itemKey, global = false) {
        if(global) {
            const globalErrorMessage = document.getElementById('global-cart-drawer-message');
            message != null ? globalErrorMessage.classList.replace('hidden', 'block') : globalErrorMessage.classList.replace('block', 'hidden');
            globalErrorMessage.innerHTML = message != null ? `<p class="text-white text-sm font-Lato">${message}</p>` : '';
        } else {
            const productItem = document.getElementById('product-' + itemKey);
            if(message != null && productItem.querySelector('.error-message') != null) {
                productItem.querySelectorAll('.error-message').forEach(errorMessage => {
                    errorMessage.innerHTML = `<p class="text-red-500 text-sm font-Lato">${message}</p>`;
                });
            } else if(productItem.querySelector('.error-message') != null) {
                productItem.querySelectorAll('.error-message').forEach(errorMessage => {
                    errorMessage.innerHTML = '';
                });
            }
        }
    }

    clickEventListeners() {
        const { promoButton, promoInput } = this.cartComponents();

        document.querySelectorAll('.remove-product').forEach(removeButton => {
            removeButton.addEventListener('click', () => {
                this.removeProductFromCart(removeButton.dataset.itemKey)
            });
        });

        document.querySelectorAll('.quantity-subtract').forEach(quantitySubtractButton => {
            quantitySubtractButton.addEventListener('click', () => {
                let quantityInput = quantitySubtractButton.parentElement.querySelector('input');
                if(quantityInput.value > 1) {
                    this.updateProductQuantity(quantitySubtractButton.dataset.itemKey, quantityInput.value - 1);
                    quantityInput.value = parseInt(quantityInput.value) - 1;
                }
            })
        });

        document.querySelectorAll('.quantity-add').forEach(quantityAddButton => {
            quantityAddButton.addEventListener('click', () => {
                let quantityInput = quantityAddButton.parentElement.querySelector('input');
                this.updateProductQuantity(quantityAddButton.dataset.itemKey, parseInt(quantityInput.value) + 1);
                quantityInput.value = parseInt(quantityInput.value) + 1;
            }) 
        })

        if(promoButton != null) {
            promoButton.addEventListener('click', () => {
                this.applyPromoCode(promoInput.value);
            })
        }

    }

    renderProductProps(properties = null, sellingPlan = null, rechargeGift = null) {
        let productProps = document.createElement('div');
        if((properties != null || properties != undefined) && properties.Grind != undefined && properties.Grind != '') {
            let pTag = document.createElement('p'); 
            pTag.classList.add('text-blue-dark', 'text-sm', 'font-Roboto', 'mt-2', 'tablet:mt-5');
            pTag.textContent = `Grind: ${ properties.Grind }`;
            productProps.appendChild(pTag);
        }

        if(sellingPlan != null) {
            let pTag = document.createElement('p'); 
            pTag.classList.add('text-blue-dark', 'text-sm', 'font-Roboto', 'font-bold');
            pTag.textContent = sellingPlan.selling_plan.name;
            productProps.appendChild(pTag);
        }

        if(rechargeGift != null) {
            let pTag = document.createElement('p'); 
            pTag.classList.add('text-blue-dark', 'text-sm', 'font-Roboto', 'font-bold');
            pTag.textContent = rechargeGift;
            productProps.appendChild(pTag);
        }

        return productProps.innerHTML;

    }

    renderDrawerCard(productData) {
        const { cartCurrency } = this.cartComponents();
        let newElement = document.createElement('div');
        newElement.id = `product-${productData.key}`;
        let elementContent = document.createElement('div');

        elementContent.innerHTML = `
            <div>
                <!-- == [ PRODUCT INFORMATION ] == -->
                    <div class="flex">

                        <!-- == [ PRODUCT IMAGE ] == -->
                        <div class="w-[20%] flex flex-col">
                            <div class="w-full h-max">
                                ${ this.renderProductImage(productData.featured_image) }
                            </div>
                        </div>

                        <!-- == [ PRODUCT TITLE AND VARIANT ] == -->
                        <div class="w-[60%] flex flex-col px-[10px] relative">
                            <div class="w-full h-max">
                                <h4 class="text-[14px] text-black font-Lato font-semibold">
                                    ${ productData.product_title }
                                </h4>                                
                                <p class=" ${ productData.variant_title != null ? 'mt-2 ' : '' } font-Roboto text-black text-xs font-medium"> 
                                    ${ productData.variant_title != null ? productData.variant_title : '' }
                                </p>
                            </div>

                            ${this.renderProductProps(productData.properties, productData.selling_plan_allocation)}

                            <div class="error-message mt-2"></div>

                        </div>
                        
                        <!-- == [ PRODUCT QUANTITY AND PRICE] == -->
                        <div class="w-[20%] flex flex-col relative">
                            <div class="w-full h-max">
                                <div class="flex items-center justify-center quantity-selector">

                                    <button data-item-key="${ productData.key }" class="w-[12px] tablet:w-[24px] h-[12px] tablet:h-[24px] flex items-center justify-center quantity-subtract" type="button" aria-label="Decrement quantity by one">
                                        <svg class="w-[14px] h-[14px] object-contain"aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" viewBox="0 0 16 2">
                                            <rect width="16" height="2" rx="1"></rect>
                                        </svg>
                                    </button>

                                    <input class="w-[26px] h-[26px] mx-[5px] p-0 text-center" type="text" readonly value="${ productData.quantity }" min="1">
                                                                <!-- == [ PRODUCT TITLE AND VARIANT ] == -->
                                    <button data-item-key="${ productData.key }" class="w-[12px] tablet:w-[24px] h-[12px] tablet:h-[24px] flex items-center justify-center quantity-add" type="button" aria-label="Increment quantity by one">
                                        <svg class="w-[14px] h-[14px] object-contain block"aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 16 16">
                                            <path d="M8 8V0H7v8H0v1h7v8h1V9h7V8H8z"></path>
                                        </svg>
                                    </button>
                                    
                                </div>
                                
                                <h4 class="h-max mt-2 product-original-price text-right text-[#000000] text-[12px] drawer:text-[16px] font-Montserrat font-regular">
                                    ${ this.formatMoney(productData.line_price, cartCurrency) }
                                </h4>

                            </div>
                        </div> 

                    </div>
                    <!-- == [ REMOVE ITEM FROM CART ] == -->

                    <button data-item-key="${ productData.key }" class="remove-product flex gap-1 items-center mt-3">
                        <div class="w-[20px] h-[20px] flex items-center text-brown">
                            <svg w-[16px] h-[16px] viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.97558 12.8593L5.94359 12.6261L6.38148 12.1588L6.83843 11.7608L7.19657 11.3142L7.5321 11.0966L8.32814 10.1827L8.72438 9.87482L8.93165 9.57916L9.71549 8.85424L10.0381 8.47274L10.3675 8.34954L10.4153 8.09554L11.461 7.07929L12.0228 6.63529L12.492 6.0483L13.0556 5.45521L13.7033 4.8959L14.2271 4.31322L14.6337 3.96549L15.1427 3.36809L15.5893 3.00995L15.8971 2.61371L16.1971 2.46105L16.4 2.11078L16.7208 1.87837L17.2801 1.23067L17.7813 0.87685L18.1193 0.862874L18.3751 0.66602L18.6758 0.866162L18.9288 1.3203L19.1958 1.43637L19.2364 1.77875L19.6628 1.85316L20.181 2.57247L19.9763 3.07183L19.5825 3.58338L19.0606 4.01696L18.8576 4.36722L18.4258 4.7401L18.0001 5.01848L17.0471 6.17774L16.6466 6.43098L15.8904 7.33446L15.4395 7.63799L14.9115 8.16606L14.7085 8.51632L14.2559 8.96895L13.8051 9.27248L13.4365 9.75889L11.9026 11.2928L11.6087 11.351L11.45 11.7454L10.9176 12.2189L10.3791 12.7868L9.85713 13.2204L9.65418 13.5707L9.27267 13.8933L8.44717 14.7777L7.95822 14.9425L8.05525 15.1401L7.69888 15.4376L7.68772 15.1247L7.34355 15.2331L7.5056 15.3952L7.22899 15.6718L7.62345 15.513L6.93155 16.0281L6.94882 16.2466L6.46673 16.6697L6.05398 17.112L5.5823 17.4952L5.4652 17.7302L5.03772 18.1577L4.42558 18.652L4.04661 19.1782L3.58535 19.5217L3.14745 19.989L2.38293 19.9286L1.35783 18.8029L0.806669 18.3523L0.896083 17.9388L1.06525 17.5045L1.68959 16.8212L1.9601 16.6391L2.92174 15.5891L3.45844 15.1702L4.22324 14.376L4.43051 14.0803L5.10767 13.5505L5.60018 13.0874L5.97558 12.8593ZM5.36667 16.827L5.22546 16.5852L5.55414 16.1092L6.05959 15.81L6.00245 15.602L6.26254 15.4597L6.37964 15.2248L6.34764 14.9916L5.41724 15.922L5.11398 15.5182L5.27273 15.1237L4.88156 15.839L4.55645 16.0168L4.69335 16.2039L4.91966 15.9776L5.26636 16.0729L4.93768 16.5489L5.05807 16.8704L5.36667 16.827ZM7.79851 12.922L7.70731 13.4846L7.38295 14.0152L6.93388 14.1697L6.74566 14.5347L6.39793 14.9413L6.67708 14.8684L6.72202 15.2654L6.9778 15.0685L6.84446 14.5832L7.39843 14.3827L7.24577 14.6827L7.79035 14.0203L7.98645 13.4117L7.79851 12.922ZM12.4805 9.50695L12.4 9.17498L12.6913 8.91311L12.4703 8.69213L12.7556 8.52475L12.2034 8.57606L12.1645 8.08458L12.0413 8.41402L11.828 8.80416L12.1912 8.76504L12.3141 9.2903L12.1909 9.61973L11.6265 9.86002L11.9707 9.75156L12.2272 9.9075L12.5922 9.71929L12.3296 9.65783L12.4805 9.50695ZM8.62044 12.3358L8.96105 12.5255L9.37455 12.4361L9.70145 12.1092L9.43882 12.0477L9.87494 11.7295L9.96257 11.4651L9.59682 11.3005L9.78655 11.6411L9.48226 11.7391L9.13454 12.1458L8.62044 12.3358ZM6.77642 13.2075L6.72969 12.9596L6.96464 12.8425L7.31134 12.9378L7.79597 12.7183L7.48051 12.5034L7.77363 12.0925L8.02256 11.6373L7.32635 12.0978L7.53868 12.2096L7.27935 12.7046L6.88235 12.6597L6.53462 13.0663L6.77642 13.2075ZM6.53332 14.4229L6.62706 14.064L7.11271 13.3426L6.5943 13.478L6.60547 13.791L6.16682 13.9055L5.85287 14.3962L6.29762 14.1872L6.53332 14.4229ZM8.89678 12.9139L8.80586 12.6218L8.34384 12.6124L8.49218 12.2578L8.85464 11.8659L8.46628 11.9301L8.53384 12.0983L8.06292 12.8344L8.1955 12.967L8.48505 12.8542L8.39132 13.2131L8.89678 12.9139ZM4.18028 15.8921L3.89682 15.9103L3.58288 16.4011L4.08833 16.1019L3.81173 16.3785L4.30067 16.2136L4.15411 16.4191L4.45408 16.2664L4.49752 15.9578L4.36926 15.8799L4.44291 15.9535L4.18028 15.8921ZM10.1152 11.1651L10.5158 10.9118L10.0972 10.5938L9.59429 11.0968L9.98875 10.938L10.1152 11.1651ZM4.99613 15.4003L4.58008 15.286L4.91562 15.0683L4.8186 14.8707L5.14549 14.5438L4.24202 15.3L4.5783 15.4351L4.99613 15.4003ZM5.86685 14.0582L5.80539 13.7955L5.43354 13.7255L5.69364 13.5832L5.34515 13.6371L5.39873 14.1433L5.86685 14.0582ZM3.41775 17.7447L3.70045 17.3736L3.6009 16.9723L3.274 17.2992L3.41521 17.541L3.23919 17.717L3.41775 17.7447ZM13.8955 8.35708L13.8958 7.50239L13.483 7.9446L13.7517 7.91158L13.69 8.50364L13.8955 8.35708ZM9.64992 10.5992L9.46705 10.5169L9.60929 10.2568L9.84678 10.3434L9.82417 10.5723L10.0645 10.0079L9.69693 9.99239L9.34742 10.5481L9.64992 10.5992ZM5.81197 14.9085L6.10584 14.8504L6.16148 14.3528L5.85287 14.3962L5.81731 14.4613L5.81197 14.9085ZM10.5402 10.5339L10.7812 10.3223L10.3246 9.86564L10.4744 10.2167L10.1978 10.4933L10.5402 10.5339ZM7.29936 15.1889L7.15382 14.8925L6.75402 15.4986L6.84241 15.5869L7.29936 15.1889ZM13.1429 8.96237L13.1066 8.67459L12.8292 8.5984L12.7944 9.01622L12.9417 9.16354L13.1429 8.96237ZM15.6557 6.59686L15.8777 6.31594L15.8978 5.88338L15.6499 5.83665L15.4236 6.06297L15.7469 6.03426L15.6557 6.59686ZM8.16884 12.2865L8.07538 11.7907L7.78912 12.46L8.16884 12.2865ZM10.8546 11.2507L11.1815 10.9238L10.8643 10.858L10.6283 11.477L11.0263 11.02L10.8546 11.2507ZM11.7383 10.0724L11.323 10.3109L11.0845 10.7262L11.5059 10.3932L11.7383 10.0724ZM9.36798 11.3231L9.4739 10.7752L9.05505 11.3119L9.36798 11.3231ZM8.67375 13.6967L8.8828 13.2519L9.03012 13.3992L9.15941 12.9753L8.80915 13.1783L8.67375 13.6967ZM11.611 9.49249L11.5194 8.8476L11.3545 9.33654L11.611 9.49249ZM11.149 9.4831L10.9461 9.83337L10.8628 10.1524L11.129 9.91566L11.149 9.4831ZM10.6753 10.8702L10.9224 10.5641L10.7101 10.4524L10.5661 10.8615L10.6753 10.8702ZM9.33522 10.7371L8.94864 10.6523L8.9052 10.9609L9.33522 10.7371ZM8.54117 13.5641L8.49444 13.3162L8.10506 13.8824L8.54117 13.5641ZM9.26739 11.4237L8.93186 11.6413L8.99332 11.904L9.26739 11.4237ZM10.8066 9.44247L10.9194 9.15291L10.5189 9.40616L10.8066 9.44247ZM7.92122 11.3851L7.61008 11.2248L7.56232 11.4788L7.92122 11.3851ZM14.9699 7.01749L14.5816 7.08176L14.5841 7.28546L14.9699 7.01749ZM5.07718 14.0229L5.07464 13.8192L4.86484 13.9111L4.89252 14.0897L5.07718 14.0229ZM10.4789 12.3334L10.5371 12.0396L10.231 12.2867L10.4789 12.3334ZM12.8643 7.32589L12.5877 7.60249L12.8963 7.55905L12.8643 7.32589ZM8.75713 10.4608L8.36268 10.6195L8.48053 10.7374L8.75713 10.4608ZM17.2247 3.79044L17.3375 3.50088L17.0314 3.74802L17.2247 3.79044ZM11.5552 7.92788L11.4668 7.83949L11.3159 7.99037L11.4043 8.07876L11.5552 7.92788ZM14.7571 5.69825L14.6748 5.51537L14.5369 5.83007L14.7571 5.69825ZM6.70304 12.2792L6.62938 12.2055L6.47851 12.3564L6.55216 12.4301L6.70304 12.2792ZM10.357 11.3063L10.2686 11.2179L10.1429 11.3436L10.2313 11.432L10.357 11.3063ZM13.024 9.34641L12.9062 9.22856L12.7891 9.46351L13.024 9.34641ZM18.1315 3.59078L18.0726 3.53185L17.8965 3.70787L17.9555 3.7668L18.1315 3.59078ZM9.27445 13.7442L9.21553 13.6852L9.11494 13.7858L9.17387 13.8447L9.27445 13.7442ZM4.41976 17.8918L4.36083 17.8328L4.26025 17.9334L4.31917 17.9923L4.41976 17.8918ZM11.5524 8.57887L11.4935 8.51995L11.3929 8.62053L11.4518 8.67946L11.5524 8.57887ZM11.9758 7.24209L11.9169 7.18316L11.8163 7.28375L11.8752 7.34267L11.9758 7.24209ZM14.9083 4.69268L14.8493 4.63375L14.7487 4.73434L14.8077 4.79326L14.9083 4.69268ZM3.97528 17.2461L3.91635 17.1872L3.81577 17.2878L3.8747 17.3467L3.97528 17.2461ZM11.3504 11.3441L11.2915 11.2852L11.1909 11.3858L11.2498 11.4447L11.3504 11.3441ZM17.1656 1.66933L17.1066 1.6104L17.0061 1.71099L17.065 1.76991L17.1656 1.66933ZM19.4363 2.93417L19.3773 2.87525L19.2768 2.97583L19.3357 3.03476L19.4363 2.93417ZM4.21557 16.6817L4.08984 16.8075L4.17823 16.8958L4.21557 16.6817ZM18.9237 3.82977L18.798 3.9555L18.8716 4.02916L18.9237 3.82977ZM2.82391 17.9555L2.77971 17.9113L2.67913 18.0119L2.72332 18.0561L2.82391 17.9555ZM10.61 11.7604L10.5511 11.7015L10.4756 11.7769L10.5346 11.8359L10.61 11.7604ZM15.3172 5.40335L15.273 5.35915L15.1724 5.45974L15.2166 5.50393L15.3172 5.40335ZM2.33626 16.7638L2.27734 16.7049L2.2019 16.7803L2.26082 16.8392L2.33626 16.7638ZM14.7899 6.28421L14.7309 6.22529L14.6555 6.30072L14.7144 6.35965L14.7899 6.28421ZM15.3576 3.68355L15.3134 3.63935L15.2128 3.73993L15.257 3.78413L15.3576 3.68355ZM8.72658 13.8501L8.68239 13.8059L8.5818 13.9065L8.626 13.9507L8.72658 13.8501ZM19.4919 2.4366L19.433 2.37767L19.3575 2.45311L19.4165 2.51203L19.4919 2.4366ZM16.0444 5.6779L15.9854 5.61897L15.91 5.69441L15.9689 5.75334L16.0444 5.6779ZM8.18454 14.7162L8.14034 14.672L8.06491 14.7475L8.1091 14.7917L8.18454 14.7162ZM9.66815 13.2326L9.62396 13.1884L9.54852 13.2639L9.59272 13.308L9.66815 13.2326ZM13.1241 8.03834L13.0799 7.99414L12.9984 8.16407L13.1241 8.03834ZM6.56834 16.0673L6.36032 16.0101L6.43398 16.0838L6.56834 16.0673ZM11.4661 7.4867L11.4071 7.42777L11.4305 7.55172L11.4661 7.4867ZM10.7419 8.62334L10.8425 8.52275L10.6621 8.64417L10.7419 8.62334ZM14.0342 8.39518L14.1348 8.2946L13.9544 8.41601L14.0342 8.39518ZM4.45456 17.4739L4.55515 17.3733L4.37481 17.4948L4.45456 17.4739ZM3.9278 16.6454L4.00323 16.57L3.84804 16.6662L3.9278 16.6454Z" fill="currentColor"/>
                                <path d="M8.0086 5.49292L8.24177 5.46092L8.70913 5.89882L9.10715 6.35576L9.55368 6.71391L9.77136 7.04944L10.6853 7.84548L10.9931 8.24172L11.2888 8.44898L12.0137 9.23283L12.3952 9.55541L12.5184 9.88484L12.7724 9.9326L13.7886 10.9783L14.2326 11.5402L14.8196 12.0093L15.4127 12.5729L15.972 13.2206L16.5547 13.7444L16.9024 14.151L17.4998 14.6601L17.858 15.1066L18.2542 15.4144L18.4069 15.7144L18.7571 15.9174L18.9895 16.2382L19.6372 16.7975L19.9911 17.2986L20.005 17.6367L20.2019 17.8925L20.0018 18.1932L19.5476 18.4461L19.4316 18.7131L19.0892 18.7537L19.0148 19.1802L18.2955 19.6983L17.7961 19.4936L17.2845 19.0999L16.851 18.5779L16.5007 18.375L16.1278 17.9432L15.8494 17.5175L14.6902 16.5644L14.4369 16.1639L13.5335 15.4077L13.2299 14.9569L12.7019 14.4288L12.3516 14.2259L11.899 13.7732L11.5954 13.3224L11.109 12.9538L9.57512 11.4199L9.51695 11.1261L9.12249 10.9673L8.64903 10.4349L8.08109 9.89643L7.64751 9.37446L7.29724 9.17151L6.97466 8.79L6.09023 7.9645L5.92538 7.47556L5.72778 7.57258L5.43034 7.21622L5.74326 7.20505L5.6348 6.86088L5.47275 7.02293L5.19614 6.74632L5.3549 7.14078L4.83978 6.44889L4.62135 6.46615L4.19818 5.98406L3.75597 5.57131L3.37268 5.09963L3.13773 4.98254L2.71025 4.55505L2.21596 3.94292L1.68968 3.56394L1.34627 3.10268L0.878905 2.66478L0.939339 1.90026L2.06502 0.875163L2.5156 0.324003L2.9291 0.413417L3.36344 0.582588L4.0467 1.20692L4.22882 1.47743L5.27885 2.43908L5.6977 2.97578L6.49196 3.74057L6.78762 3.94784L7.31746 4.625L7.78051 5.11751L8.0086 5.49292ZM4.04094 4.88401L4.28274 4.74279L4.75873 5.07147L5.05795 5.57693L5.26597 5.51978L5.40821 5.77988L5.64316 5.89697L5.87633 5.86498L4.94592 4.93457L5.34977 4.63131L5.74422 4.79007L5.02897 4.3989L4.85116 4.07378L4.66397 4.21068L4.89029 4.43699L4.79504 4.78369L4.31905 4.45502L3.9975 4.5754L4.04094 4.88401ZM7.94591 7.31584L7.38331 7.22464L6.8527 6.90028L6.69827 6.45121L6.33327 6.26299L5.92662 5.91527L5.99952 6.19441L5.60253 6.23936L5.79938 6.49514L6.28476 6.3618L6.48517 6.91577L6.1852 6.76311L6.84763 7.30769L7.45621 7.50379L7.94591 7.31584ZM11.361 11.9978L11.6929 11.9173L11.9548 12.2086L12.1758 11.9877L12.3432 12.2729L12.2919 11.7207L12.7833 11.6819L12.4539 11.5587L12.0638 11.3453L12.1029 11.7085L11.5776 11.8314L11.2482 11.7082L11.0079 11.1439L11.1164 11.488L10.9604 11.7446L11.1486 12.1096L11.2101 11.8469L11.361 11.9978ZM8.53214 8.13778L8.34242 8.47838L8.43183 8.89189L8.75873 9.21879L8.82019 8.95616L9.13846 9.39227L9.40287 9.47991L9.56745 9.11416L9.22685 9.30389L9.1288 8.9996L8.72214 8.65187L8.53214 8.13778ZM7.66039 6.29376L7.90829 6.24703L8.02539 6.48198L7.93015 6.82868L8.14961 7.3133L8.36448 6.99785L8.77545 7.29097L9.23062 7.53989L8.77011 6.84368L8.65836 7.05602L8.16332 6.79668L8.20826 6.39969L7.80161 6.05196L7.66039 6.29376ZM6.44502 6.05066L6.80392 6.14439L7.52528 6.63004L7.38989 6.11164L7.07696 6.12281L6.9624 5.68415L6.47168 5.37021L6.68073 5.81496L6.44502 6.05066ZM7.95406 8.41411L8.24615 8.32319L8.25554 7.86117L8.61012 8.00951L9.00204 8.37197L8.93777 7.98361L8.76963 8.05117L8.03354 7.58025L7.90096 7.71283L8.01374 8.00239L7.65484 7.90866L7.95406 8.41411ZM4.97587 3.69762L4.95757 3.41416L4.46685 3.10021L4.76606 3.60567L4.48946 3.32906L4.65431 3.818L4.44883 3.67144L4.60148 3.97142L4.91009 4.01485L4.98806 3.88659L4.9144 3.96025L4.97587 3.69762ZM9.70284 9.63257L9.95608 10.0331L10.2741 9.61454L9.77115 9.11162L9.92991 9.50608L9.70284 9.63257ZM5.46762 4.51346L5.58191 4.09742L5.79959 4.43295L5.99719 4.33593L6.32409 4.66283L5.56793 3.75935L5.43281 4.09564L5.46762 4.51346ZM6.80975 5.38418L7.07237 5.32272L7.14247 4.95087L7.28471 5.21097L7.23086 4.86249L6.72465 4.91607L6.80975 5.38418ZM3.12321 2.93508L3.4943 3.21779L3.89561 3.11823L3.56871 2.79133L3.32691 2.93255L3.15089 2.75653L3.12321 2.93508ZM12.5108 13.4128L13.3655 13.4131L12.9233 13.0004L12.9563 13.2691L12.3643 13.2073L12.5108 13.4128ZM10.2687 9.16726L10.351 8.98438L10.6111 9.12663L10.5245 9.36411L10.2957 9.3415L10.86 9.58179L10.8755 9.21426L10.3198 8.86475L10.2687 9.16726ZM5.95937 5.3293L6.01754 5.62317L6.51512 5.67881L6.47168 5.37021L6.40666 5.33465L5.95937 5.3293ZM10.334 10.0575L10.5456 10.2986L11.0023 9.84189L10.6513 9.99173L10.3747 9.71513L10.334 10.0575ZM5.67899 6.81669L5.9754 6.67116L5.36936 6.27136L5.28097 6.35974L5.67899 6.81669ZM11.9056 12.6602L12.1933 12.6239L12.2695 12.3466L11.8517 12.3117L11.7044 12.4591L11.9056 12.6602ZM14.2711 15.1731L14.552 15.3951L14.9845 15.4151L15.0313 15.1672L14.805 14.9409L14.8337 15.2643L14.2711 15.1731ZM8.58141 7.68618L9.07721 7.59272L8.40792 7.30645L8.58141 7.68618ZM9.61726 10.3719L9.94416 10.6988L10.0099 10.3816L9.39095 10.1456L9.84789 10.5436L9.61726 10.3719ZM10.7956 11.2556L10.5571 10.8403L10.1418 10.6018L10.4748 11.0232L10.7956 11.2556ZM9.54484 8.88531L10.0927 8.99124L9.55601 8.57239L9.54484 8.88531ZM7.17124 8.19109L7.61599 8.40014L7.46868 8.54745L7.8926 8.67674L7.68965 8.32648L7.17124 8.19109ZM11.3754 11.1284L12.0203 11.0367L11.5314 10.8718L11.3754 11.1284ZM11.3848 10.6664L11.0346 10.4634L10.7155 10.3801L10.9523 10.6463L11.3848 10.6664ZM9.99774 10.1926L10.3038 10.4398L10.4156 10.2274L10.0064 10.0834L9.99774 10.1926ZM10.1308 8.85256L10.2156 8.46598L9.90703 8.42254L10.1308 8.85256ZM7.30382 8.05851L7.55172 8.01178L6.98556 7.62239L7.30382 8.05851ZM9.44425 8.78472L9.22657 8.44919L8.96394 8.51065L9.44425 8.78472ZM11.4254 10.324L11.715 10.4368L11.4618 10.0362L11.4254 10.324ZM9.48283 7.43855L9.6431 7.12741L9.3891 7.07966L9.48283 7.43855ZM13.8504 14.4873L13.7862 14.0989L13.5825 14.1014L13.8504 14.4873ZM6.84503 4.59451L7.04874 4.59198L6.95679 4.38218L6.77823 4.40986L6.84503 4.59451ZM8.53447 9.99626L8.82834 10.0544L8.5812 9.74836L8.53447 9.99626ZM13.542 12.3816L13.2654 12.105L13.3089 12.4136L13.542 12.3816ZM10.4071 8.27447L10.2484 7.88001L10.1305 7.99786L10.4071 8.27447ZM17.0775 16.742L17.367 16.8548L17.1199 16.5488L17.0775 16.742ZM12.94 11.0725L13.0284 10.9841L12.8775 10.8333L12.7892 10.9217L12.94 11.0725ZM15.1697 14.2744L15.3525 14.1922L15.0378 14.0542L15.1697 14.2744ZM8.58874 6.22037L8.6624 6.14672L8.51152 5.99584L8.43787 6.0695L8.58874 6.22037ZM9.56162 9.87437L9.65001 9.78598L9.52428 9.66025L9.43589 9.74863L9.56162 9.87437ZM11.5215 12.5414L11.6394 12.4235L11.4044 12.3064L11.5215 12.5414ZM17.2771 17.6488L17.3361 17.5899L17.16 17.4139L17.1011 17.4728L17.2771 17.6488ZM7.12376 8.79179L7.18268 8.73286L7.0821 8.63228L7.02317 8.6912L7.12376 8.79179ZM2.97617 3.93709L3.03509 3.87817L2.93451 3.77758L2.87558 3.83651L2.97617 3.93709ZM12.289 11.0697L12.348 11.0108L12.2474 10.9102L12.1885 10.9691L12.289 11.0697ZM13.6258 11.4932L13.6848 11.4342L13.5842 11.3337L13.5252 11.3926L13.6258 11.4932ZM16.1752 14.4256L16.2342 14.3667L16.1336 14.2661L16.0747 14.325L16.1752 14.4256ZM3.62181 3.49261L3.68074 3.43369L3.58016 3.3331L3.52123 3.39203L3.62181 3.49261ZM9.5238 10.8677L9.58273 10.8088L9.48214 10.7082L9.42322 10.7672L9.5238 10.8677ZM19.1986 16.6829L19.2575 16.624L19.1569 16.5234L19.098 16.5823L19.1986 16.6829ZM17.9337 18.9536L17.9927 18.8947L17.8921 18.7941L17.8332 18.853L17.9337 18.9536ZM4.1862 3.7329L4.06047 3.60718L3.97208 3.69556L4.1862 3.7329ZM17.0382 18.441L16.9124 18.3153L16.8388 18.3889L17.0382 18.441ZM2.91238 2.34124L2.95658 2.29705L2.85599 2.19646L2.8118 2.24066L2.91238 2.34124ZM9.10749 10.1273L9.16641 10.0684L9.09097 9.99297L9.03205 10.0519L9.10749 10.1273ZM15.4646 14.8345L15.5088 14.7903L15.4082 14.6897L15.364 14.7339L15.4646 14.8345ZM4.10412 1.8536L4.16304 1.79467L4.0876 1.71923L4.02868 1.77816L4.10412 1.8536ZM14.5837 14.3072L14.6426 14.2483L14.5672 14.1728L14.5083 14.2318L14.5837 14.3072ZM17.1844 14.8749L17.2286 14.8307L17.128 14.7302L17.0838 14.7743L17.1844 14.8749ZM7.01783 8.24392L7.06202 8.19972L6.96144 8.09914L6.91725 8.14333L7.01783 8.24392ZM18.4313 19.0092L18.4902 18.9503L18.4148 18.8749L18.3559 18.9338L18.4313 19.0092ZM15.19 15.5617L15.2489 15.5028L15.1735 15.4273L15.1146 15.4862L15.19 15.5617ZM6.15169 7.70187L6.19589 7.65768L6.12045 7.58224L6.07626 7.62643L6.15169 7.70187ZM7.63531 9.18549L7.67951 9.14129L7.60407 9.06586L7.55987 9.11005L7.63531 9.18549ZM12.8296 12.6415L12.8738 12.5973L12.7039 12.5157L12.8296 12.6415ZM4.80066 6.08567L4.8578 5.87765L4.78415 5.95131L4.80066 6.08567ZM13.3812 10.9834L13.4401 10.9245L13.3162 10.9478L13.3812 10.9834ZM12.2446 10.2592L12.3452 10.3598L12.2238 10.1795L12.2446 10.2592ZM12.4727 13.5515L12.5733 13.6521L12.4519 13.4718L12.4727 13.5515ZM3.39399 3.9719L3.49458 4.07248L3.37316 3.89214L3.39399 3.9719ZM4.22251 3.44513L4.29795 3.52057L4.20168 3.36538L4.22251 3.44513Z" fill="currentColor"/>
                            </svg>
                        </div>
                        <p class="text-xs font-medium font-Roboto">Remove Item</p>
                    </button>
            </div>
        `;
        newElement.appendChild(elementContent);
        return newElement;
    }

    updateTotalPrice() {
        const { cartCurrency } = this.cartComponents();
        fetch('/cart.js')
        .then(response => response.json())
        .then(cartData => {
            document.getElementById('cart-drawer-footer').querySelector('.orderSummaryTotal').textContent = this.formatMoney(cartData.original_total_price, cartCurrency);
        })
        .catch(error => {
            console.error('Error fetching cart:', error);
        });
    }

    addProductToDrawer(cartData) {

        document.getElementById('empty-drawer-cart').classList.replace('block', 'hidden');
        document.getElementById('cart-drawer-container').classList.replace('hidden', 'block');
        document.getElementById('cart-drawer-footer').classList.replace('hidden', 'block');
        document.getElementById('cart-drawer-total-items').classList.replace('hidden', 'flex');

        let drawerItems = document.querySelector('#cart-drawer-items');
        cartData.items.forEach(item => {
            if(document.getElementById(`product-${item.key}`) != null) {
                document.getElementById(`product-${item.key}`).remove();
            }
            drawerItems.insertBefore(this.renderDrawerCard(item), drawerItems.firstChild); 
        });
        this.updateTotalPrice();
        this.clickEventListeners();
    }

    renderProductImage(productImage) {
        if(productImage != undefined || productImage != null) {
            return `
                <img 
                    class="w-full h-full object-contain"
                    src="${productImage.url}"
                    width="${productImage.width}"
                    height="${productImage.height}"
                    alt="${productImage.alt}"
                    loading="lazy"
                >
            `;
        }
        return `
            <svg class="w-full h-full object-contain" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5">
                <path d="M375.5 345.2c0-.1 0-.1 0 0 0-.1 0-.1 0 0-1.1-2.9-2.3-5.5-3.4-7.8-1.4-4.7-2.4-13.8-.5-19.8 3.4-10.6 3.6-40.6 1.2-54.5-2.3-14-12.3-29.8-18.5-36.9-5.3-6.2-12.8-14.9-15.4-17.9 8.6-5.6 13.3-13.3 14-23 0-.3 0-.6.1-.8.4-4.1-.6-9.9-3.9-13.5-2.1-2.3-4.8-3.5-8-3.5h-54.9c-.8-7.1-3-13-5.2-17.5-6.8-13.9-12.5-16.5-21.2-16.5h-.7c-8.7 0-14.4 2.5-21.2 16.5-2.2 4.5-4.4 10.4-5.2 17.5h-48.5c-3.2 0-5.9 1.2-8 3.5-3.2 3.6-4.3 9.3-3.9 13.5 0 .2 0 .5.1.8.7 9.8 5.4 17.4 14 23-2.6 3.1-10.1 11.7-15.4 17.9-6.1 7.2-16.1 22.9-18.5 36.9-2.2 13.3-1.2 47.4 1 54.9 1.1 3.8 1.4 14.5-.2 19.4-1.2 2.4-2.3 5-3.4 7.9-4.4 11.6-6.2 26.3-5 32.6 1.8 9.9 16.5 14.4 29.4 14.4h176.8c12.9 0 27.6-4.5 29.4-14.4 1.2-6.5-.5-21.1-5-32.7zm-97.7-178c.3-3.2.8-10.6-.2-18 2.4 4.3 5 10.5 5.9 18h-5.7zm-36.3-17.9c-1 7.4-.5 14.8-.2 18h-5.7c.9-7.5 3.5-13.7 5.9-18zm4.5-6.9c0-.1.1-.2.1-.4 4.4-5.3 8.4-5.8 13.1-5.8h.7c4.7 0 8.7.6 13.1 5.8 0 .1 0 .2.1.4 3.2 8.9 2.2 21.2 1.8 25h-30.7c-.4-3.8-1.3-16.1 1.8-25zm-70.7 42.5c0-.3 0-.6-.1-.9-.3-3.4.5-8.4 3.1-11.3 1-1.1 2.1-1.7 3.4-2.1l-.6.6c-2.8 3.1-3.7 8.1-3.3 11.6 0 .2 0 .5.1.8.3 3.5.9 11.7 10.6 18.8.3.2.8.2 1-.2.2-.3.2-.8-.2-1-9.2-6.7-9.8-14.4-10-17.7 0-.3 0-.6-.1-.8-.3-3.2.5-7.7 3-10.5.8-.8 1.7-1.5 2.6-1.9h155.7c1 .4 1.9 1.1 2.6 1.9 2.5 2.8 3.3 7.3 3 10.5 0 .2 0 .5-.1.8-.3 3.6-1 13.1-13.8 20.1-.3.2-.5.6-.3 1 .1.2.4.4.6.4.1 0 .2 0 .3-.1 13.5-7.5 14.3-17.5 14.6-21.3 0-.3 0-.5.1-.8.4-3.5-.5-8.5-3.3-11.6l-.6-.6c1.3.4 2.5 1.1 3.4 2.1 2.6 2.9 3.5 7.9 3.1 11.3 0 .3 0 .6-.1.9-1.5 20.9-23.6 31.4-65.5 31.4h-43.8c-41.8 0-63.9-10.5-65.4-31.4zm91 89.1h-7c0-1.5 0-3-.1-4.2-.2-12.5-2.2-31.1-2.7-35.1h3.6c.8 0 1.4-.6 1.4-1.4v-14.1h2.4v14.1c0 .8.6 1.4 1.4 1.4h3.7c-.4 3.9-2.4 22.6-2.7 35.1v4.2zm65.3 11.9h-16.8c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h16.8v2.8h-62.2c0-.9-.1-1.9-.1-2.8h33.9c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-33.9c-.1-3.2-.1-6.3-.1-9h62.5v9zm-12.5 24.4h-6.3l.2-1.6h5.9l.2 1.6zm-5.8-4.5l1.6-12.3h2l1.6 12.3h-5.2zm-57-19.9h-62.4v-9h62.5c0 2.7 0 5.8-.1 9zm-62.4 1.4h62.4c0 .9-.1 1.8-.1 2.8H194v-2.8zm65.2 0h7.3c0 .9.1 1.8.1 2.8H259c.1-.9.1-1.8.1-2.8zm7.2-1.4h-7.2c.1-3.2.1-6.3.1-9h7c0 2.7 0 5.8.1 9zm-7.7-66.7v6.8h-9v-6.8h9zm-8.9 8.3h9v.7h-9v-.7zm0 2.1h9v2.3h-9v-2.3zm26-1.4h-9v-.7h9v.7zm-9 3.7v-2.3h9v2.3h-9zm9-5.9h-9v-6.8h9v6.8zm-119.3 91.1c-2.1-7.1-3-40.9-.9-53.6 2.2-13.5 11.9-28.6 17.8-35.6 5.6-6.5 13.5-15.7 15.7-18.3 11.4 6.4 28.7 9.6 51.8 9.6h6v14.1c0 .8.6 1.4 1.4 1.4h5.4c.3 3.1 2.4 22.4 2.7 35.1 0 1.2.1 2.6.1 4.2h-63.9c-.8 0-1.4.6-1.4 1.4v16.1c0 .8.6 1.4 1.4 1.4H256c-.8 11.8-2.8 24.7-8 33.3-2.6 4.4-4.9 8.5-6.9 12.2-.4.7-.1 1.6.6 1.9.2.1.4.2.6.2.5 0 1-.3 1.3-.8 1.9-3.7 4.2-7.7 6.8-12.1 5.4-9.1 7.6-22.5 8.4-34.7h7.8c.7 11.2 2.6 23.5 7.1 32.4.2.5.8.8 1.3.8.2 0 .4 0 .6-.2.7-.4 1-1.2.6-1.9-4.3-8.5-6.1-20.3-6.8-31.1H312l-2.4 18.6c-.1.4.1.8.3 1.1.3.3.7.5 1.1.5h9.6c.4 0 .8-.2 1.1-.5.3-.3.4-.7.3-1.1l-2.4-18.6H333c.8 0 1.4-.6 1.4-1.4v-16.1c0-.8-.6-1.4-1.4-1.4h-63.9c0-1.5 0-2.9.1-4.2.2-12.7 2.3-32 2.7-35.1h5.2c.8 0 1.4-.6 1.4-1.4v-14.1h6.2c23.1 0 40.4-3.2 51.8-9.6 2.3 2.6 10.1 11.8 15.7 18.3 5.9 6.9 15.6 22.1 17.8 35.6 2.2 13.4 2 43.2-1.1 53.1-1.2 3.9-1.4 8.7-1 13-1.7-2.8-2.9-4.4-3-4.6-.2-.3-.6-.5-.9-.6h-.5c-.2 0-.4.1-.5.2-.6.5-.8 1.4-.3 2 0 0 .2.3.5.8 1.4 2.1 5.6 8.4 8.9 16.7h-42.9v-43.8c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v44.9c0 .1-.1.2-.1.3 0 .1 0 .2.1.3v9c-1.1 2-3.9 3.7-10.5 3.7h-7.5c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h7.5c5 0 8.5-.9 10.5-2.8-.1 3.1-1.5 6.5-10.5 6.5H210.4c-9 0-10.5-3.4-10.5-6.5 2 1.9 5.5 2.8 10.5 2.8h67.4c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-67.4c-6.7 0-9.4-1.7-10.5-3.7v-54.5c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v43.8h-43.6c4.2-10.2 9.4-17.4 9.5-17.5.5-.6.3-1.5-.3-2s-1.5-.3-2 .3c-.1.2-1.4 2-3.2 5 .1-4.9-.4-10.2-1.1-12.8zm221.4 60.2c-1.5 8.3-14.9 12-26.6 12H174.4c-11.8 0-25.1-3.8-26.6-12-1-5.7.6-19.3 4.6-30.2H197v9.8c0 6.4 4.5 9.7 13.4 9.7h105.4c8.9 0 13.4-3.3 13.4-9.7v-9.8h44c4 10.9 5.6 24.5 4.6 30.2z"></path>
                <path d="M286.1 359.3c0 .4.3.7.7.7h14.7c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-14.7c-.3 0-.7.3-.7.7zm5.3-145.6c13.5-.5 24.7-2.3 33.5-5.3.4-.1.6-.5.4-.9-.1-.4-.5-.6-.9-.4-8.6 3-19.7 4.7-33 5.2-.4 0-.7.3-.7.7 0 .4.3.7.7.7zm-11.3.1c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7H242c-19.9 0-35.3-2.5-45.9-7.4-.4-.2-.8 0-.9.3-.2.4 0 .8.3.9 10.8 5 26.4 7.5 46.5 7.5h38.1zm-7.2 116.9c.4.1.9.1 1.4.1 1.7 0 3.4-.7 4.7-1.9 1.4-1.4 1.9-3.2 1.5-5-.2-.8-.9-1.2-1.7-1.1-.8.2-1.2.9-1.1 1.7.3 1.2-.4 2-.7 2.4-.9.9-2.2 1.3-3.4 1-.8-.2-1.5.3-1.7 1.1s.2 1.5 1 1.7z"></path>
                <path d="M275.5 331.6c-.8 0-1.4.6-1.5 1.4 0 .8.6 1.4 1.4 1.5h.3c3.6 0 7-2.8 7.7-6.3.2-.8-.4-1.5-1.1-1.7-.8-.2-1.5.4-1.7 1.1-.4 2.3-2.8 4.2-5.1 4zm5.4 1.6c-.6.5-.6 1.4-.1 2 1.1 1.3 2.5 2.2 4.2 2.8.2.1.3.1.5.1.6 0 1.1-.3 1.3-.9.3-.7-.1-1.6-.8-1.8-1.2-.5-2.2-1.2-3-2.1-.6-.6-1.5-.6-2.1-.1zm-38.2 12.7c.5 0 .9 0 1.4-.1.8-.2 1.3-.9 1.1-1.7-.2-.8-.9-1.3-1.7-1.1-1.2.3-2.5-.1-3.4-1-.4-.4-1-1.2-.8-2.4.2-.8-.3-1.5-1.1-1.7-.8-.2-1.5.3-1.7 1.1-.4 1.8.1 3.7 1.5 5 1.2 1.2 2.9 1.9 4.7 1.9z"></path>
                <path d="M241.2 349.6h.3c.8 0 1.4-.7 1.4-1.5s-.7-1.4-1.5-1.4c-2.3.1-4.6-1.7-5.1-4-.2-.8-.9-1.3-1.7-1.1-.8.2-1.3.9-1.1 1.7.7 3.5 4.1 6.3 7.7 6.3zm-9.7 3.6c.2 0 .3 0 .5-.1 1.6-.6 3-1.6 4.2-2.8.5-.6.5-1.5-.1-2s-1.5-.5-2 .1c-.8.9-1.8 1.6-3 2.1-.7.3-1.1 1.1-.8 1.8 0 .6.6.9 1.2.9z"></path>
            </svg>
        `;
    }

    formatMoney(cents, format) {
        format = `${format}{{amount}}`
        if (typeof cents == "string") {
          cents = cents.replace(".", "");
        }
        let value = "";
        let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        let formatString = format || this.money_format;
      
        function defaultOption(opt, def) {
          return typeof opt == "undefined" ? def : opt;
        }
      
        function formatWithDelimiters(number, precision, thousands, decimal) {
          precision = defaultOption(precision, 2);
          thousands = defaultOption(thousands, ",");
          decimal = defaultOption(decimal, ".");
      
          if (isNaN(number) || number == null) {
            return 0;
          }
      
          number = (number / 100.0).toFixed(precision);
      
          let parts = number.split("."),
            dollars = parts[0].replace(
              /(\d)(?=(\d\d\d)+(?!\d))/g,
              "$1" + thousands
            ),
            cents = parts[1] ? decimal + parts[1] : "";
      
          return dollars + cents;
        }

        switch (formatString.match(placeholderRegex)[1]) {
            case "amount":
                value = formatWithDelimiters(cents, 2);
                break;
            case "amount_no_decimals":
                value = formatWithDelimiters(cents, 0);
                break;
            case "amount_with_comma_separator":
                value = formatWithDelimiters(cents, 2, ".", ",");
                break;
            case "amount_no_decimals_with_comma_separator":
                value = formatWithDelimiters(cents, 0, ".", ",");
                break;
        }
      
        return formatString.replace(placeholderRegex, value);
    }

    applyPromoCode(promoCode) {
        // Use Shopify's AJAX API to apply the promo code
        document.cookie = `discount_code=${promoCode}; path=/`;
        // Send GET request to "/discount/[discountcode]"
        fetch(`/discount/${promoCode}`)
        .then(() => {
            // !!! PROBABLY NEED TO CHANGE THIS APPROACH TO SOMETHING ELSE !!!
            window.location.reload();
            // !!! PROBABLY NEED TO CHANGE THIS APPROACH TO SOMETHING ELSE !!!
        })
        .catch(function(error) {
            console.error('Error:', error);
        });
    }

    cartComponents() {
        const emptyCartSection = this.querySelector('#empty-cart-section');
        const cartItemsContainer = this.querySelector('#cartItemsContainer');
        const removeButtons = this.querySelectorAll('.remove-product');
        const totalItemsCount = document.querySelectorAll('.totalItemCount');
        const quantitySubtractButtons = this.querySelectorAll('.quantity-subtract');
        const quantityAddButtons = this.querySelectorAll('.quantity-add');
        const cartSubtotal = this.querySelector('#orderSubtotal');
        const cartTotal = document.querySelectorAll('.orderSummaryTotal');
        const cartCurrency = document.querySelector('#cartCurrency').dataset.currency;
        const promoInput = this.querySelector('#promoCode');
        const promoButton = this.querySelector('#promoCodeApply');
        const orderSummaryDiscount = this.querySelector('#orderSummaryDiscount');
        const cartWrapper = this.querySelector('#main-cart-wrapper');

        return { 
            emptyCartSection, removeButtons, cartItemsContainer, totalItemsCount, quantitySubtractButtons, quantityAddButtons,
            cartSubtotal, cartTotal, promoButton, promoInput, orderSummaryDiscount, cartWrapper, cartCurrency
        };
    }
} 
customElements.define('shipping-cart', ShoppingCart);

class CartDrawer extends HTMLElement {
    constructor(noListeners = false) {
        super();
        this.updatePaddingTop();
        this.resizeEvents();
        
        if(!noListeners) {
            this.clickEventListeners();
            this.shoppingCart = new ShoppingCart(true); // No listeners enabled when passing true
        }
    }

    resizeEvents() {
        window.addEventListener('resize', () => {
            this.updatePaddingTop();
        });
    }
    
    mobileScreen() {
        return window.innerWidth <= 750;
    }

    updatePaddingTop() {
        if(!this.mobileScreen()) {
            const { drawerWrapper, navigation, announcementBar } = this.drawerComponents();
            const navigationFilters = document.querySelector('.collection-filters')
            let totalPaddingTop = 0;
    
            navigation != null ? totalPaddingTop += navigation.offsetHeight : null;

            announcementBar != null ? totalPaddingTop += announcementBar.offsetHeight : null;
            if(navigationFilters != null) {
                navigationFilters.classList.contains('hidden') ? totalPaddingTop -= navigationFilters.offsetHeight : null;
            }
            drawerWrapper.style.paddingTop = `${totalPaddingTop}px`;
        }
    }

    showCartDrawer(state) {
        if(window.location.href.includes("/cart")) { return; }
        const { cartOverlay, drawerWrapper, pageBody, navigation, announcementBar  } = this.drawerComponents();
        const navigationFilters = document.querySelector('.collection-filters')

        state ? cartOverlay.classList.remove('invisible') : cartOverlay.classList.add('invisible');
        state ? drawerWrapper.classList.replace('hidden', 'fixed') : drawerWrapper.classList.replace('fixed', 'hidden');
        state ? pageBody.classList.add('overflow-hidden') : pageBody.classList.remove('overflow-hidden');
        pageBody.classList.replace('fixed', 'relative');

        if(navigationFilters != null) {
            state ? navigationFilters.classList.add('hidden') : navigationFilters.classList.remove('hidden');
        }
        this.updatePaddingTop();

        //Add fixed on mobile when opening drawer to prevent from scrolling (IOS)
        if(this.mobileScreen() && state) {
            pageBody.classList.replace('relative', 'fixed');
            navigation != null ? navigation.classList.add('hidden') : null;
            announcementBar != null ? announcementBar.classList.add('hidden') : null;
        } else if(this.mobileScreen() && !state) {
            navigation != null ? navigation.classList.remove('hidden') : null;
            announcementBar != null ? announcementBar.classList.remove('hidden') : null;
        }
    }

    clickEventListeners() {
        const { cartDrawerClose, headerDrawerOpen, cartDrawerRemoveBtns, cartDrawerQuantitySubtractButtons, cartDrawerQuantityAddButtons, cartDrawerNoteButton } = this.drawerComponents();

        cartDrawerClose.forEach(closeButton => {
            closeButton.addEventListener('click', () => {
                this.showCartDrawer(false);
            });
        });

        if(headerDrawerOpen != null) {
            headerDrawerOpen.addEventListener('click', () => {
                this.showCartDrawer(true);
            });
        }

        cartDrawerRemoveBtns.forEach(removeButton => {
            removeButton.addEventListener('click', () => {
                this.shoppingCart.removeProductFromCart(removeButton.dataset.itemKey);
            });
        });

        cartDrawerQuantitySubtractButtons.forEach(quantitySubtractButton => {
            quantitySubtractButton.addEventListener('click', () => {
                let quantityInput = quantitySubtractButton.parentElement.querySelector('input');
                if(quantityInput.value > 1) {
                    quantityInput.value = parseInt(quantityInput.value) - 1;
                    this.shoppingCart.updateProductQuantity(quantitySubtractButton.dataset.itemKey, quantityInput.value);
                }
            })
        });

        cartDrawerQuantityAddButtons.forEach(quantityAddButton => {
            quantityAddButton.addEventListener('click', () => {
                let quantityInput = quantityAddButton.parentElement.querySelector('input');
                quantityInput.value = parseInt(quantityInput.value) + 1;
                this.shoppingCart.updateProductQuantity(quantityAddButton.dataset.itemKey, quantityInput.value);
            })
        })

        cartDrawerNoteButton.addEventListener('click', () => {
            this.toggleCartDrawerOrderNote();
        });

    }

    toggleCartDrawerOrderNote() {
        const { cartDrawerNoteSection, cartDrawerNoteButtonPlus, cartDrawerNoteButtonMinus } = this.drawerComponents();

        if(cartDrawerNoteSection.classList.contains('hidden')) {
            cartDrawerNoteSection.classList.replace('hidden', 'block');

            cartDrawerNoteButtonPlus.classList.add('hidden');
            cartDrawerNoteButtonMinus.classList.remove('hidden');
        } else {
            cartDrawerNoteSection.classList.replace('block', 'hidden');
            cartDrawerNoteButtonMinus.classList.add('hidden');
            cartDrawerNoteButtonPlus.classList.remove('hidden');
        }
    }

    drawerComponents() {
        const cartOverlay = document.querySelector('#cart-overlay');
        const drawerWrapper = document.querySelector('#drawer-wrapper');
        const cartDrawerClose = document.querySelectorAll('.cart-drawer-close');
        const headerDrawerOpen = document.querySelector('#cart-drawer-open');
        const cartDrawerFooter = this.querySelector('#cart-drawer-footer');
        const cartDrawerItems = this.querySelector('#cart-drawer-items');
        const pageBody = document.body;
        const navigation = document.querySelector('#navigation-header-wrapper');
        const announcementBar = document.querySelector('#announcement-bar');
        const cartDrawerRemoveBtns = this.querySelectorAll('.remove-product');
        const cartDrawerQuantitySubtractButtons = this.querySelectorAll('.quantity-subtract');
        const cartDrawerQuantityAddButtons = this.querySelectorAll('.quantity-add');

        const cartDrawerNoteButton = this.querySelector('#cart-drawer-note-button');
        const cartDrawerNoteSection = this.querySelector('#cart-drawer-note-section');
        const cartDrawerNoteButtonPlus = this.querySelector('#note-button-plus');
        const cartDrawerNoteButtonMinus = this.querySelector('#note-button-minus');

        return { 
            cartOverlay, drawerWrapper, cartDrawerClose, headerDrawerOpen, pageBody, navigation, 
            announcementBar, cartDrawerFooter, cartDrawerItems, cartDrawerRemoveBtns, cartDrawerQuantitySubtractButtons,
            cartDrawerQuantityAddButtons, cartDrawerNoteButton, cartDrawerNoteSection, cartDrawerNoteButtonPlus, cartDrawerNoteButtonMinus
        };
    }
}

customElements.define('cart-drawer', CartDrawer);

const cart = new ShoppingCart(true); // No listeners enabled when passing true
const cartDrawer = new CartDrawer(true); // No listeners enabled when passing true

// button - button element
// checkout - go directly to checkout after adding to cart 
// checkGiftMessage - check if product contains gift message
const addSingleProductToCart = (button, checkout = false, checkGiftMessage = false) => {
    let quantity = document.querySelector('.atc-input').value;
    let parentElement = button.parentElement;
    let form = parentElement.closest('#add-to-cart-btns');
    let sellingPlan = null;
    let giftForm = null;
    if(form != null) {
        sellingPlan = form.querySelector('input[name="selling_plan"]') != null ? form.querySelector('input[name="selling_plan"]').value : null;
    }

    if(checkGiftMessage) {
        const giftCardForm = document.getElementById('gift-subscription-form');
        if(giftCardForm != null || giftCardForm != undefined) {
            giftForm = {
                name: giftCardForm.querySelector('#recipient_name').value,
                email: giftCardForm.querySelector('#recipient_email').value,
            }
        }
    }

    const grindOption = parentElement.querySelector('#product-buyNow-form-grind') != null ? parentElement.querySelector('#product-buyNow-form-grind').value : null;

    const rechargeGiftInputs = document.querySelectorAll('div.rc_gifting_container input, div.rc_gifting_container textarea');
    console.log("Inputs:", rechargeGiftInputs);

    const rechargeGift = Array.from(rechargeGiftInputs).map(input => input.value);
  
    console.log(rechargeGift);  // This will output an array of names
    
    cart.addProductToCart(
        button.dataset.variantid, 
        quantity, 
        checkout, 
        grindOption,
        rechargeGift, 
        sellingPlan,
        giftForm
    ); //Third (optional) argument: true, is for checkout redirect
    cartDrawer.showCartDrawer(true);
}

const addProductToCartCollectionPage = (button, checkout = false, checkGiftMessage = false) => {
    let quantity = 1;
    let parentElement = button.parentElement;
    let form = parentElement.closest('#add-to-cart-btns');
    let sellingPlan = null;
    let giftForm = null;
    if(form != null) {
        sellingPlan = form.querySelector('input[name="selling_plan"]') != null ? form.querySelector('input[name="selling_plan"]').value : null;
    }

    if(checkGiftMessage) {
        const giftCardForm = document.getElementById('gift-subscription-form');
        if(giftCardForm != null || giftCardForm != undefined) {
            giftForm = {
                name: giftCardForm.querySelector('#recipient_name').value,
                email: giftCardForm.querySelector('#recipient_email').value,
            }
        }
    }

    const grindOption = parentElement.querySelector('#product-buyNow-form-grind') != null ? parentElement.querySelector('#product-buyNow-form-grind').value : null;

    const rechargeGiftInputs = document.querySelectorAll('div.rc_gifting_container input, div.rc_gifting_container textarea');
    console.log("Inputs:", rechargeGiftInputs);

    const rechargeGift = Array.from(rechargeGiftInputs).map(input => input.value);
  
    console.log(rechargeGift);  // This will output an array of names
    
    cart.addProductToCart(
        button.dataset.variantid, 
        quantity, 
        checkout, 
        grindOption,
        rechargeGift, 
        sellingPlan,
        giftForm
    ); //Third (optional) argument: true, is for checkout redirect
    cartDrawer.showCartDrawer(true);
}

const addProductToCart = (button, checkout = false, checkGiftMessage = false) => {
    let quantity = document.querySelector('.atc-input').value;
    let parentElement = button.parentElement;
    const grindOption = parentElement.querySelector('#product-buyNow-form-grind') != null ? parentElement.querySelector('#product-buyNow-form-grind').value : null;
    
    const rechargeGiftInputs = document.querySelectorAll('div.rc_gifting_container input, div.rc_gifting_container textarea');
    console.log("Inputs:", rechargeGiftInputs);

    const rechargeGift = Array.from(rechargeGiftInputs).map(input => input.value);
  
    console.log(rechargeGift);  // This will output an array of names
    
    let giftForm = null;
    let form = parentElement.closest('#add-to-cart-btns');

    let sellingPlan = form.querySelector('input[name="selling_plan"]') != null ? form.querySelector('input[name="selling_plan"]').value : null;

    if(checkGiftMessage) {
        const giftCardForm = document.getElementById('gift-subscription-form');
        if(giftCardForm != null || giftCardForm != undefined) {
            giftForm = {
                name: giftCardForm.querySelector('#recipient_name').value,
                email: giftCardForm.querySelector('#recipient_email').value,
            }
        }
    }

    cart.addProductToCart(
        button.dataset.variantid, 
        quantity, 
        checkout, 
        grindOption,
        rechargeGift, 
        sellingPlan,
        giftForm
    ); //Third (optional) argument: true, is for checkout redirect
    cartDrawer.showCartDrawer(true);
} 

//Update cart notes

document.querySelectorAll('.cart-notes').forEach(cartNote => {
    cartNote.addEventListener(
        'change',
        debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${window.Shopify.routes.root + 'cart/update.js'}`, { ...fetchConfig(), ...{ body } });
        }, ON_CHANGE_DEBOUNCE_TIMER)
    );
});
